import React from 'react';
import _ from 'lodash';
import RCore from 'RCore';

import config from 'cfg';
import SMStream from '../SMStream';

var ProTopListLabels = [
    {
        text: 'Goals',
        value: 'eventsStats.goals'
    },
    {
        text: 'Assists',
        value: 'eventsStats.assists'
    },
    {
        text: 'Top speed',
        value: 'maxStats.distanceData.topSpeed'
    },
    {
        text: 'Average distance',
        value: 'averageStats.distanceData.distance'
    }
];

class EISMStream extends SMStream {
    renderToolbar() {
        return <h1>Standings</h1>;
    }

    prepareTopLists = (tournament, seasonId, params = {}) => {
        let tournamentId = tournament.id;
        let hasPro = RCore.isProStatsDataAvailable(tournamentId, seasonId);
        if (!hasPro) return [];
        return ProTopListLabels.map(p => ({
            groupKey: 'season-top-list-' + params.teamId,
            groupTitle: 'Top players, season',
            name: 'ProTopListSMWidget',
            props: {
                'data-tournament-id': tournamentId,
                'data-sort-by': p.value,
                'data-team-id': params.teamId
            },
            key: `pro-top-list-${tournamentId}-${params.teamId}-${p.value}`
        }));
    };

    prepareLastRoundTopLists = (round, tournament, seasonId, params = {}) => {
        return false;
        let tournamentId = tournament.id;
        let hasPro = RCore.isProStatsDataAvailable(tournamentId, seasonId);
        if (!hasPro) return [];
        return ProTopListLabels.map(p => ({
            groupKey: `season-top-round-${round}`,
            groupTitle: `Top players, Runde ${round}`,
            name: 'ProTopListSMWidget',
            props: {
                'data-tournament-id': tournamentId,
                'data-round': round,
                'data-sort-by': p.value,
                'data-team-id': params.teamId
            },
            key: `pro-top-list-${tournamentId}-${round}`
        }));
    };

    prepareTables = (tournament, seasonId, params) => {
        let tournamentId = tournament.id;

        return [
            {
                name: 'TopListSMWidget',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-season-id': seasonId
                },
                key: `top-list-${tournamentId}`
            },
            {
                name: 'LeagueTrackerSMWidget',
                props: RCore.prepareWidgetPropsObj({
                    'data-tournament-id': tournamentId,
                    'data-season-id': seasonId,
                    'data-stage-id': params.stageId,
                    'data-show-all-charts': true,
                    'data-line-smoothing': true,
                    'data-show-team-name-badge': true,
                    'data-team1-id': params.teamId,
                    'data-team2-id': params.team2Id
                }),
                key: `lt-list-${tournamentId}`
            },

            {
                name: 'AnimatedTournamentTable',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-season-id': seasonId,
                    'data-stage-id': params.stageId
                },
                key: `table-list-${tournamentId}-animated`
            },
            {
                name: 'TournamentTableSMWidget',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-season-id': seasonId,
                    'data-limit': 5,
                    'data-team-id': params.teamId,
                    'data-team2-id': params.team2Id,
                    'data-stage-id': params.stageId,
                    'data-qual-rel': true
                },
                key: `table-list-${tournamentId}`
            },
            {
                name: 'TournamentTableSMWidget',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-full': true,
                    'data-team-id': params.teamId,
                    'data-team2-id': params.team2Id,
                    'data-stage-id': params.stageId
                },
                key: `table-full-${tournamentId}`
            },
            {
                name: 'TournamentTableSMWidget',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-full': true,
                    'data-qual-rel': true,
                    'data-team-id': params.teamId,
                    'data-team2-id': params.team2Id,
                    'data-stage-id': params.stageId
                },
                key: `table-full-w-q-l-${tournamentId}`
            },
            {
                name: 'TournamentTableSMWidget',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-limit': 3,
                    'data-team-id': params.teamId,
                    'data-team2-id': params.team2Id,
                    'data-stage-id': params.stageId
                },
                key: `table-limit-3-${tournamentId}`
            },

            {
                name: 'TournamentTableSMWidget',
                props: {
                    'data-tournament-id': tournamentId,
                    'data-limit': -5,
                    'data-team-id': params.teamId,
                    'data-team2-id': params.team2Id,
                    'data-stage-id': params.stageId
                },
                key: `table-limit-5-${tournamentId}`
            }
        ];
    };

    loadSMWidgetsForEvent = params => {
        let { tournamentId, seasonId, teamId, eventId } = params;
        return RCore.promiseProps({
            event: fetch(`${config.apis.ss2}/events/${eventId}`).then(response => response.json()),
            tournament:
                this.props.tournament ||
                fetch(`${config.apis.ss2}/tournaments/${tournamentId}`).then(response => response.json())
        }).then(result => {
            let { tournament, event } = result;
            let { round } = event.properties;
            let stageId = event.tournamentStageId;
            let teamId = event.homeId;
            let team2Id = event.awayId;
            return _.compact([
                ...this.prepareTables(tournament, seasonId, { teamId, team2Id, stageId }),
                ...this.prepareTopLists(tournament, seasonId, { teamId, team2Id, stageId }),
                ...this.prepareTopLists(tournament, seasonId, { teamId: team2Id, stageId }),
                ...this.prepareLastRoundTopLists(round, tournament, seasonId, { teamId, team2Id, stageId })
            ]);
        });
    };

    loadSMWidgetsForLeague = params => {
        let { tournamentId, seasonId, teamId } = params;

        return RCore.promiseProps({
            tournament:
                this.props.tournament ||
                fetch(`${config.apis.ss2}/tournaments/${tournamentId}`).then(response => response.json()),
            latestEvent: fetch(
                `${
                    config.apis.ss2
                }/events-v2?ttId=${tournamentId}&status=finished&limit=1&sortBy=startDate&sortDirection=desc`
            )
                .then(response => response.json())
                .then(r => r.events[0])
        }).then(result => {
            let { tournament, latestEvent } = result;
            let { round } = latestEvent.properties;
            return _.compact([
                ...this.prepareTables(tournament, seasonId, { teamId }),
                ...this.prepareTopLists(tournament, seasonId, { teamId }),
                ...this.prepareLastRoundTopLists(round, tournament, seasonId, { teamId })
            ]);
        });
    };

    loadSMWidgetsForMixedTournament = (tournament, stages, params) => {
        return _.compact([
            {
                name: 'TopListSMWidget',
                groupTitle: 'Top List Goals',
                groupKey: 'Goals',
                props: {
                    'data-tournament-id': tournament.id,
                    'data-season-id': _.get(tournament, 'currentSeason.id', null),
                    'data-sort-by': 'stats.goals'
                },
                key: `top-list-${tournament.id}`
            },
            {
                name: 'TopListSMWidget',
                groupTitle: 'Top List Assists',
                groupKey: 'Assists',
                props: {
                    'data-tournament-id': tournament.id,
                    'data-season-id': _.get(tournament, 'currentSeason.id', null),
                    'data-sort-by': 'stats.assists'
                },
                key: `top-list-${tournament.id}`
            },
            ..._.filter(stages, s => !s.isCup).map(stage => ({
                name: 'TournamentTableSMWidget',
                props: {
                    'data-tournament-id': tournament.id,
                    'data-season-id': _.get(tournament, 'currentSeason.id', null),
                    'data-stage-id': stage.id,
                    'data-full': true,
                    'data-qual-rel': true
                },
                key: `table-list-${tournament.id}-${stage.id}`
            })),
            tournament.id === 46 && {
                name: 'TournamentGroupTableSMWidget',
                props: {
                    'data-tournament-id': tournament.id,
                    'data-qual-rel': true
                },
                key: `table-limit-5-${tournament.id}`
            }
        ]);
    };

    loadSMWidgets = params => {
        let { tournamentId, seasonId, teamId, eventId } = params;

        // if in context of event
        if (eventId) return this.loadSMWidgetsForEvent(params);

        console.log('!!-!!-!!-!!', tournamentId, this.props.tournament);
        return RCore.promiseProps({
            tournament:
                this.props.tournament ||
                fetch(`${config.apis.ss2}/tournaments/${tournamentId}`).then(response => response.json()),
            stages:
                this.props.stages ||
                fetch(`${config.apis.ss2}/tournaments/${tournamentId}/season`)
                    .then(response => response.json())
                    .then(r => r.season.stages)
        }).then(result => {
            let { tournament, stages } = result;

            if (tournament.type === 'cup') return this.loadSMWidgetsForCup(params);
            if ((tournament.type === 'league' || tournament.currentType === 'table') && stages.length === 1)
                return this.loadSMWidgetsForLeague(params);
            else return this.loadSMWidgetsForMixedTournament(tournament, stages, params);
        });
    };
}

export default EISMStream;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/streams/tournament/TournamentBasicSMStream.js
 **/